import { useRef, useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { ATTACHMENT } from 'hb-react/shared/components/DesignSystem/QuillEditor/constants';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';

import InputFileHidden from '../components/InputFileHidden';
import ToolbarItem from '../components/ToolbarItem';
import getFileInputClickHandler from '../utils/getFileInputClickHandler';

export const ACCEPT_ATTACHMENTS = [
  'application/pdf',
  'text/csv',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

const Attachment = () => {
  const { acceptAllFiles, onAddFiles, options, setForceEditorFocus } =
    useQuillEditorContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleAddAttachments = useCallback(
    (files: Array<File> = []) => {
      onAddFiles?.({
        type: ATTACHMENT,
        files,
      });

      setForceEditorFocus?.(false);
    },
    [onAddFiles, setForceEditorFocus],
  );

  const { toolbar: toolbarOptions, tooltips: tooltipsOptions } = options ?? {};

  return (
    <>
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={getFileInputClickHandler(inputRef)}
        icon={<FontAwesomeIcon iconName="paperclip" height="16px" />}
        disabled={
          typeof toolbarOptions?.attachments === 'object'
            ? toolbarOptions?.attachments?.disabled
            : false
        }
        dataTestId="attachments-action"
        ariaLabel={s__('QuillEditorAccessibility|Add a file')}
        tooltip={tooltipsOptions?.attachments}
        enableFontAwesomeIcon
      />
      <InputFileHidden
        key="attachment-input"
        dataTestId="attachments-action-input"
        ref={inputRef}
        accept={acceptAllFiles ? undefined : ACCEPT_ATTACHMENTS}
        onChange={handleAddAttachments}
        multiple
      />
    </>
  );
};

export default Attachment;
